import React from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";

const CustomFileInput = ({ contentName, onChange, name, required }) => {
  const [fileName, setFileName] = React.useState("");
  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
    }
    onChange(e);
  };

  return (
    <>
      <label>
        <input
          type="file"
          name={name}
          style={{ display: "none" }}
          onChange={handleChange}
        />
        <Button
          variant="contained"
          component="span"
          fullWidth
          startIcon={<CloudUploadIcon />}
        >
          {contentName} - {fileName ? fileName : "Dosya Seç"}
        </Button>
        {required && !fileName && (
          <FormHelperText error>Bu alan zorunludur.</FormHelperText>
        )}
      </label>
    </>
  );
};

export default CustomFileInput;
